module.exports = __webpack_public_path__ + "static/BTT_SC-419b0b2d7aff1dbd0fd41118cf318910.png";